import * as types from './ActionTypes';

export const requestSocialGroupRide = (groupRideUUID, activityId, evictCache) => ({
    type: types.FETCH_SOCIAL_GROUP_RIDE,
    groupRideUUID: groupRideUUID,
    activityId: activityId,
    meta: {
        cacheTime: evictCache ? null : 5000
    }
});
export const receiveSocialGroupRide = (json) => ({
    type: types.FETCH_SOCIAL_GROUP_RIDE_SUCCESS,
    groupRide: json,
    receivedAt: Date.now()
});

export const requestSocialGroupRideCompetitions = (groupRideUUID, activityId, evictCache) => ({
    type: types.FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS,
    groupRideUUID: groupRideUUID,
    activityId: activityId,
    meta: {
        cacheTime: evictCache ? null : 5000
    }
});

export const receiveSocialGroupRideCompetitions = (json) => ({
    type: types.FETCH_SOCIAL_GROUP_RIDE_COMPETITIONS_SUCCESS,
    socialGroupRideCompetitions: json,
    receivedAt: Date.now()
});

export const receiveSocialGroupRideFailed = (json) => ({
    type: types.FETCH_SOCIAL_GROUP_RIDE_FAIL,
    receivedAt: Date.now()
});

export const deleteSocialGroupRideUserData = (groupRideUUID) => ({
    type: types.DELETE_SOCIAL_GROUP_RIDE_USER_DATA,
    groupRideUUID: groupRideUUID
});

export const dismissSocialGroupRideDataDeleteSuccess = () => ({
    type: types.DISMISS_SOCIAL_GROUP_RIDE_DATA_DELETE_SUCCESS
});
